export function QuestionIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M20 12a8 8 0 10-16 0 8 8 0 0016 0zm2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM10.497 8.602C10.18 8.959 10 9.463 10 10a1 1 0 11-2 0c0-.963.32-1.959 1.003-2.727C9.702 6.487 10.729 6 12 6c1.115 0 2.118.295 2.859.926C15.617 7.573 16 8.487 16 9.5c0 .645-.134 1.268-.476 1.855-.337.578-.838 1.056-1.47 1.477-.707.472-.935.747-1.009.87-.038.063-.045.075-.045.298a1 1 0 11-2 0v-.016c0-.28 0-.76.33-1.311.301-.502.823-.977 1.615-1.505.461-.307.71-.58.85-.82.135-.23.205-.493.205-.848 0-.487-.17-.823-.439-1.051C13.276 8.205 12.78 8 12 8c-.729 0-1.202.263-1.503.602zM13 17a1 1 0 11-2 0 1 1 0 012 0z"
      ></path>
    </svg>
  );
}
